import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import {AppointmentTemplate,CommonService, ServiceLevel, DeleteServiceLevel, NetworkMember,  GetServiceLevels, CompassStateModel, CompassState, GetProviderSettings, ProviderSetting, SaveProviderSetting, GetDocuments, GetAppointmentTemplates, ChecklistTemplate, GetChecklistTemplates } from 'huddyapi';

import moment_ from 'moment';
import { Observable, Subscription } from 'rxjs';
import { SavedProvider } from '../settings.component';
import { EditServiceLevelsDialog } from '../../components/edit-service-levels-dialog/edit-service-levels-dialog.component';


const moment = moment_;

@Component({
  selector: 'service-levels',
  templateUrl: './service-levels.component.html',
  styleUrls: ['./service-levels.component.scss']
})
export class ServiceLevelsComponent implements OnInit {

  @Input() provider : SavedProvider;
  @Select(state => state.compassState) serviceLevelsState$: Observable<CompassStateModel>;
  serviceLevelsSubscription : Subscription;
  serviceLevels : ServiceLevel[];
  useRandomServiceLevelAssignment : boolean = false;
  selectedTab : string = 'serviceLevels';
  appointmentTemplates : AppointmentTemplate[];
  checklistTemplates : ChecklistTemplate[];
  retrievedServiceLevels : boolean = false;


  constructor(
    private store : Store,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {


  }

  ngOnInit(): void {
    this.  serviceLevelsSubscription  = this.serviceLevelsState$.subscribe((compassState: CompassStateModel) => {
      // console.log(compassState);
      if (compassState && compassState.serviceLevels && !this.retrievedServiceLevels ) {
         this.serviceLevels = [].concat(compassState.serviceLevels);
         console.log('this service levels', this.serviceLevels, this.appointmentTemplates);
         if (!this.appointmentTemplates && this.serviceLevels && this.serviceLevels.length > 0) {
          const serviceLevelIds : number[] = this.serviceLevels.map(s => s.id);
          console.log('serviceLevelIds', serviceLevelIds);
          this.retrievedServiceLevels = true;
          this.store.dispatch(new GetAppointmentTemplates(serviceLevelIds));
          this.store.dispatch(new GetChecklistTemplates(this.provider.id));
         }

      }
      if (compassState && compassState.providerSettings ) {
        let randomAssignmentSetting : ProviderSetting = compassState.providerSettings.find(s => s.name === CompassState.SETTING_ASSIGN_SERVICE_LEVELS_RANDOM);
       //console.log('randomAssignmentSetting', randomAssignmentSetting, (randomAssignmentSetting && randomAssignmentSetting.value === 'true'));
        this.useRandomServiceLevelAssignment =  (randomAssignmentSetting && randomAssignmentSetting.value === 'true') ? true : false;
      }
      if (compassState && compassState.appointmentTemplates && compassState.appointmentTemplates.length > 0) {
        this.appointmentTemplates = [].concat(compassState.appointmentTemplates);
      }
      if (compassState && compassState.checklistTemplates && compassState.checklistTemplates.length > 0) {
        this.checklistTemplates = [].concat(compassState.checklistTemplates);
      }
      // console.log(this.serviceLevels, this.serviceLevels.map(g => g.name));   
    });

    console.log('service level provider', this.provider);
    this.store.dispatch(new GetServiceLevels(this.provider.id));
    this.store.dispatch(new GetProviderSettings(this.provider.id));
   
  }

  ngOnChanges(changes : SimpleChanges) {
    if (changes['provider']) {
      console.log('ngOnchanges', this.provider.id);
      this.retrievedServiceLevels = false;
      this.store.dispatch(new GetServiceLevels(this.provider.id));
      this.store.dispatch(new GetProviderSettings(this.provider.id));
      this.store.dispatch(new GetDocuments(undefined,  undefined, this.provider.id, CommonService.currentUserToView, undefined));
      this.serviceLevels = [];
    }
   
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  getServicesAsString(serviceLevel : ServiceLevel) : string {
    return serviceLevel.services.map(s => s.name).join(', ');
  }

  editServiceLevel(serviceLevel? : ServiceLevel) {
    console.log('editServiceLevel', serviceLevel);
    let appointmentTemplates = (serviceLevel && this.appointmentTemplates) ?  this.appointmentTemplates.filter(a => a.serviceLevelId === serviceLevel.id) : [];
    let numberOfFamilies = serviceLevel && serviceLevel.familyCount ? serviceLevel.familyCount : 0;
    let s : ServiceLevel | undefined = serviceLevel ? serviceLevel : undefined;
    let data = {
      serviceLevel: s,
      provider: this.provider,
      appointmentTemplates : appointmentTemplates,
      checklistTemplates : this.checklistTemplates,
      numberOfFamilies : numberOfFamilies
    };

    console.log('Service level edit', data);

    const  dialogRef : MatDialogRef<EditServiceLevelsDialog> = this.dialog.open(EditServiceLevelsDialog, {
      width: '600px',
      height: '725px',
      data: data
    });
    
    dialogRef.componentInstance.cleanup();
    dialogRef.componentInstance.data = data;
    dialogRef.componentInstance.initialize();


    dialogRef.afterClosed().subscribe(result => {
      this.retrievedServiceLevels = false;
      this.store.dispatch(new GetServiceLevels(this.provider.id));

    });
   
  }


  deleteServiceLevel(serviceLevel : ServiceLevel) {
    this.retrievedServiceLevels = false;
    this.store.dispatch(new DeleteServiceLevel(serviceLevel)).subscribe( );
  }

  toggleRandomAssignment() {
    
    this.useRandomServiceLevelAssignment = !this.useRandomServiceLevelAssignment;
    const setting : ProviderSetting = new ProviderSetting({
      name : CompassState.SETTING_ASSIGN_SERVICE_LEVELS_RANDOM,
      value : ''+this.useRandomServiceLevelAssignment,
      providerId: this.provider.id
    });
    let action = new SaveProviderSetting(setting);
    console.log('toggleRandomAssignment', action);
    this.store.dispatch(action).subscribe( );
  }

}